/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTenfourEmailControl.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/tenfour-email-control";

export class AutogenModelTenfourEmailControl<RowType extends ModelRow> extends Endpoint<RowType, RowTenfourEmailControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTenfourEmailControl extends ModelRow<RowTenfourEmailControlFields> {
	constructor(values?: Partial<RowTenfourEmailControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTenfourEmailControlFields {
	company_id: string;
	customer_id: string;
	date_ftp_sent: Date;
	date_sent: Date;
	email_list: string;
	error_email: string;
	is_active: string;
}

